import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/pageable';

const PAGE_SIZE = 10;

function usePrepaidGiftBoxes() {
    const queryInfo = useInfiniteQuery({
        queryKey: userPrepaidCardQueries.giftBoxes(PAGE_SIZE).queryKey,
        queryFn: ({ pageParam }) => PrepaidCardApi.getGiftBoxes(pageParam, PAGE_SIZE),
        initialPageParam: 0,
        getNextPageParam,
    });

    return {
        ...queryInfo,
        gifts: getFlattenPageResponse(queryInfo) ?? [],
        isEmpty: getIsBlank(queryInfo),
    };
}

export default usePrepaidGiftBoxes;
